import { render } from "./ProductCategoryListView.vue?vue&type=template&id=58d14e2e"
import script from "./ProductCategoryListView.vue?vue&type=script&lang=js"
export * from "./ProductCategoryListView.vue?vue&type=script&lang=js"

import exportComponent from "/home/rampa/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__